import React from 'react'

const Phone = props => (
  <svg viewBox="0 0 61 60" {...props}>
    <path
      d="M58.8 53.307c-.897 2.09-3.288 3.453-5.21 4.517-2.52 1.363-5.08 2.173-7.941 2.173-3.971 0-7.56-1.62-11.19-2.94-2.604-.938-5.123-2.089-7.471-3.537-7.259-4.475-16.012-13.21-20.497-20.455-1.451-2.342-2.605-4.857-3.545-7.456C1.623 21.987 0 18.406 0 14.444c0-2.856.812-5.411 2.178-7.926C3.247 4.601 4.613 2.215 6.704 1.32 8.114.682 11.1 0 12.64 0c.298 0 .598 0 .896.128.897.297 1.837 2.387 2.263 3.24 1.367 2.43 2.69 4.901 4.1 7.287.683 1.108 1.965 2.471 1.965 3.794 0 2.6-7.73 6.393-7.73 8.692 0 1.15 1.07 2.643 1.665 3.665 4.313 7.757 9.694 13.127 17.467 17.43 1.024.598 2.52 1.661 3.673 1.661 2.306 0 6.105-7.712 8.71-7.712 1.322 0 2.689 1.279 3.801 1.96 2.391 1.408 4.867 2.728 7.303 4.091.855.426 2.946 1.364 3.246 2.259.129.297.129.597.129.894-.006 1.527-.689 4.511-1.328 5.918z"
      fill="#FFF"
    />
  </svg>
)

export default Phone



// WEBPACK FOOTER //
// ./src/components/Icons/Phone.js